export const environment = {
  production: false,
  apiUrls: {
    baseUrl: 'https://beta.dev.store.3shape.com/catalog'
  },
  adApp: {
    clientId: "c36ef70e-5f18-4f71-80e8-25783745e1f8",
    authority: "https://login.microsoftonline.com/c3b232d6-15a2-46e1-8879-7ec7a9e5c4a9/",
    redirectUri: "https://admin.dev.store.3shape.com"
  },
  authScope: "api://c36ef70e-5f18-4f71-80e8-25783745e1f8/Management.Resync"
};
